import { Injectable } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';

@Injectable({
  providedIn: 'root'
})

/** This class handles the spinner and its mode, color and active status */
export class SpinnerService {

  private _mode: ProgressSpinnerMode = 'indeterminate';
  private _color: ThemePalette = 'accent';
  private _active: boolean = false;
  
  constructor() { console.log('ProgressBarService') }

  get mode() { return this._mode; }
  set mode(v: ProgressSpinnerMode) { this._mode = v; }

  get color() { return this._color; }
  set color(v: ThemePalette) { this._color = v; }

  public get active() : boolean { return this._active; }
  public set active(v : boolean) { this._active = v; }


  /**
   * The "show" function sets the "_active" property to true.
   */
  public show() {
    this._active = true;
  }

  /**
   * The "hide" function sets the "_active" property to false.
   */
  public hide() {
    this._active = false;
  }

  /**
   * The function toggles the value of the "_active" variable.
   */
  public toggle() {
    this._active = !this._active;
  }

}
